import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class StringToArrayAdapter implements JsonCustomConvert<any[]> {
    serialize(value: any[]): string {
        return value ? value.join(',') : undefined;
    }

    deserialize(value: string): any[] {
        return value ? value.split(',') : [];
    }
}
